import React from "react";
import Productpage from "../../productpage2";

import SEO from "../../seo";

export default function PostureCarePage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-04.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-01.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-02.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-03.png",
    ],
    productName: "Posture Care",

    descriptionTitle: "",
    descriptionText:
      "Posture Care brings together heavy gauge Bonnell springs and a thick layer of pressure relieving, temperature sensitive Visco Elastic Memory Foam in combination with a layer of orthobond foam to give added support. It distributes the bodyweight equally, preventing the build up of pressure points in your back, neck and hips. It also improves the body's posture ensuring a restful sleep throughout the night.",
    availableSizes: "6″ & 8″",
    category: { title: "Luxury Collection", link: "/luxury-collection" },
    points: [
      "Premium heavy gauge Bonnell Springs",
      "Combination of temperature-sensitive Visco Elastic Memory Foam & Orthobond foam",
      "Extra support that eliminates the ‘sinking in’ feeling ",
    ],
    featuresText: [
      "Memory Foam Quilted Top",
      "Ortho Rebonded Foam",
      "Turkish Cotton Felt",
      "Imported PP Mesh",
      "Eclipse Hard Foam Encasement",
      "Chiropractic Bonnell Spring",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-11.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-06.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-07.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-08.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-09.png",
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-10.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/posture-care/Posture-Care-n-05.png",
    price: "₹23,899 - ₹80,099",
    relatedProducts: [
      {
        title: "Posture Therapy",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/posture-therapy.jpg",
        link: "/luxury-collection/posture-therapy/",
      },
      {
        title: "Coil On Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/coiloncoil.jpg",
        link: "/patent-series-mattress/coil-on-coil/",
      },
      {
        title: "Ortho Care",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-care.jpg",
        link: "/ortho-mattress/ortho-care/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Posture Care Memory Foam Mattress | Eclipse International"
        description="Pressure relieving and temperature sensitive memory foam mattress with 10 years warranty from Eclipse International."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-posturecare.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
